import { Space, Typography } from 'antd';

import { RuleMessage } from '@app/domain-interfaces';

import { RuleLevelRenderer } from './rule-level-renderer';

export type RuleMessagesPanelProps = {
  title?: string;
  messages: RuleMessage[];
  showBulletIcons?: boolean;
};

export const RuleMessagesPanel = ({ title, messages, showBulletIcons = false }: RuleMessagesPanelProps) => (
  <Space direction="vertical">
    {title ? <Typography.Text>{title}</Typography.Text> : undefined}
    {messages?.map((x, i) => (
      <Space key={i}>
        {showBulletIcons ? (
          <div>
            <RuleLevelRenderer messageLevel={x.level} />
          </div>
        ) : undefined}
        <div>{x.text}</div>
      </Space>
    ))}
  </Space>
);
